export enum EConsentSigner {
  PATIENT = 'PATIENT',
  POA = 'POA',
  STAFF = 'STAFF',
  CLINICIAN = 'CLINICIAN',
}
